/** These strings aren't customer-facing: these don't need to be localized. */
export const PROGRAM_NUDGE = {
  name: 'Dr. Hammond',
  programTitle: 'Genetic Engineering: Resurrection',
  programUrl: 'https://www.imdb.com/title/tt0107290/',
  companyLogoUrl:
    'https://static.wikia.nocookie.net/logopedia/images/f/f3/Jurassic_Park_-_Logo.png/revision/latest/scale-to-width-down/185?cb=20230523215921',
};
